var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": _vm.width,
      "persistent": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pt-5 pb-0",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('Title', {
    staticClass: "pb-1",
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 18,
      "title": "Помощь"
    }
  }), _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Фамилия Имя Отчество")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.message.fullName,
      callback: function callback($$v) {
        _vm.$set(_vm.message, "fullName", $$v);
      },
      expression: "message.fullName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Электронная почта")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.message.email,
      callback: function callback($$v) {
        _vm.$set(_vm.message, "email", $$v);
      },
      expression: "message.email"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-lazy', [_c('v-textarea', {
    attrs: {
      "placeholder": "Введите данные",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "auto-grow": "",
      "rows": "1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Опишите суть проблемы")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.message.questionBody,
      callback: function callback($$v) {
        _vm.$set(_vm.message, "questionBody", $$v);
      },
      expression: "message.questionBody"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "limit": 1
    },
    on: {
      "set-files": _vm.addFile
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6 mt-2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v(_vm._s('Отмена'))]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "disabled": _vm.$v.$invalid || _vm.filesData.invalid,
      "text": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" " + _vm._s('Принять') + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }